import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import Isvg from 'react-inlinesvg'
import addIcon from '../../../assets/svg/add-icon.svg';
import garbageIcon from '../../../assets/svg/garbage.svg';

import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';


class DynamicListText extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: []
        };
    }
    componentDidMount() {
        let value = this.getValue(this.props.value);
        this.setState({ value }, () => {
            if (this.state.value?.length) {
                this.initialSetValue = true;
            }
        });

    }
    getValue = (val = null) => {
        const multilang = this.props.multilang ? this.props.multilang : false;
        let value = val ?? this.state.value ?? [];

        let _value = [];
        for (let i = 0; i < value.length; i++) {
            let _val = value[i];
            if (multilang) {
                if (typeof _val === 'object') {
                    _value.push(_val)
                }
            } else {
                if (typeof _val === 'string') {
                    _value.push(_val)
                }
            }
        }

        return _value;
    }
    componentDidUpdate(prevProps) {
        if (!this.initialSetValue && !prevProps?.value?.length && this.props?.value?.length) {
            this.initialSetValue = true;
            let value = this.getValue(this.props.value);
            this.setState({ value });
        }

    }
    closeAddItemModal = () => {
        this.setState({ addItemModal: false, newItem: null })
    }
    addNewItem = () => {
        let value = this.state.value ?? [];
        value.push(this.state.newItem);
        this.setState({ value }, () => {
            this.closeAddItemModal();
            this.onChange();
        });
    }
    removeItem = (idx) => {
        let value = this.state.value ?? [];
        value.splice(idx, 1);
        this.setState({ value }, () => {
            this.onChange();
        });
    }
    onChange = () => {
        let value = this.state.value ?? [];
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }
    render() {
        const multilang = this.props.multilang ? this.props.multilang : false;
        const value = this.getValue();
        const label = this.props.label ?? null;
        const labels = multilang && value?.length ? Object.keys(value[0]) : [];


        return (
            <div className='dynamic-list-text-wrap'>
                {label ? <div className='dynamic-list-text-label'>{label}</div> : null}
                <div className='dynamic-list-text-value'>
                    {
                        !value?.length ?
                            <div className='dynamic-list-text-no-items'>{'No items added'.translate(this.props.lang)}</div>
                            :
                            null
                    }
                    {
                        multilang ?
                            <table className='dynamic-list-text-table'>
                                {
                                    labels?.length ?
                                        <thead>
                                            <tr>
                                                <th>{'SE'.translate(this.props.lang)}</th>
                                                <th>{'EN'.translate(this.props.lang)}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        :
                                        null
                                }
                                <tbody>
                                    {
                                        value?.map((item, idx) => {
                                            return (
                                                <tr key={idx}>
                                                    <td>{item?.se}</td>
                                                    <td>{item.en}</td>
                                                    <td>
                                                        <div className='dynamic-list-text-item-remove' onClick={() => {
                                                            this.removeItem(idx);
                                                        }}>
                                                            <Isvg src={garbageIcon} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }

                                </tbody>
                            </table>
                            :
                            value.map((item, idx) => {
                                return (
                                    <div key={idx} className='dynamic-list-text-item'>
                                        {item}
                                        <div className='dynamic-list-text-item-remove' onClick={() => {
                                            this.removeItem(idx);

                                        }}>
                                            <Isvg src={garbageIcon} />
                                        </div>
                                    </div>
                                )
                            })
                    }
                </div>
                <div className='dynamic-list-text-add' onClick={() => {
                    this.setState({ addItemModal: true })
                }}>
                    <Isvg src={addIcon} />
                    <span>{'Add item'.translate(this.props.lang)}</span>
                </div>

                {
                    this.state.addItemModal ?
                        <Modal isOpen={this.state.addItemModal} centered className='create-payment-modal-wrap'>
                            <ModalHeader
                                toggle={() => this.closeAddItemModal()}
                                close={
                                    <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.closeAddItemModal()}>&times;</button>
                                }
                            >
                                {'Add item'.translate(this.props.lang)}
                            </ModalHeader>

                            <ModalBody className='create-payment-modal-body'>
                                <Row>

                                    <Col lg="12">
                                        {
                                            multilang ?
                                                <div className=''>
                                                    <FormGroup>
                                                        <Label>{'SE'.translate(this.props.lang)}</Label>
                                                        <Input
                                                            type="text"
                                                            value={this.state.newItem?.se}
                                                            onChange={(e) => {
                                                                let value = e.target.value;
                                                                let newItem = this.state.newItem ?? {};
                                                                newItem.se = value;
                                                                this.setState({ newItem });
                                                            }}
                                                        />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label>{'EN'.translate(this.props.lang)}</Label>
                                                        <Input
                                                            type="text"
                                                            value={this.state.newItem?.en}
                                                            onChange={(e) => {
                                                                let value = e.target.value;
                                                                let newItem = this.state.newItem ?? {};
                                                                newItem.en = value;
                                                                this.setState({ newItem });
                                                            }}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                :
                                                <Input
                                                    type="text"
                                                    value={this.state.newItem}
                                                    onChange={(e) => {
                                                        let value = e.target.value;
                                                        this.setState({ newItem: value });
                                                    }}
                                                />
                                        }

                                    </Col>

                                </Row>





                            </ModalBody>
                            <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: 'center' }}>
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        this.addNewItem();
                                    }}
                                    style={{ minWidth: 100 }}
                                    disabled={!multilang ? !this.state.newItem || !this.state.newItem.trim() : (!this.state.newItem?.en || !this.state.newItem?.en.trim() || !this.state.newItem?.se || !this.state.newItem?.se.trim())}
                                >
                                    {'Add'.translate(this.props.lang)}
                                </Button>
                                <Button style={{ minWidth: 100 }} color="primary" className='red-button' onClick={() => this.closeAddItemModal()}>{'Cancel'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
            </div>

        );
    }
}

export default DynamicListText;